module.exports = __webpack_public_path__ + "static/media/icon-cadastral-advisory-001.4b8aace8.svg";